import { render } from "./ShipmentNoticeCardList.vue?vue&type=template&id=d6e83f12"
import script from "./ShipmentNoticeCardList.vue?vue&type=script&lang=js"
export * from "./ShipmentNoticeCardList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__